import { render } from "./Procuradores.vue?vue&type=template&id=5e00e364&scoped=true"
import script from "./Procuradores.vue?vue&type=script&lang=js"
export * from "./Procuradores.vue?vue&type=script&lang=js"

import "./Procuradores.vue?vue&type=style&index=0&id=5e00e364&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e00e364"]])

export default __exports__